import { escapeHtml } from './escapeHtml';
import { scheduledLabel } from './schedule';

export function renderOptions(item) {
  let html = '';
  if (item.selectedOptions && item.selectedOptions.length > 0) {
    html += item.selectedOptions
      .map(o => `<div style="font-size:12px;color:#444;margin-left:12px;margin-top:2px">↳ ${o.title ? escapeHtml(o.title) + ': ' : ''}${escapeHtml(o.selectedItem)}${o.extraPrice > 0 ? ' (+' + o.extraPrice.toFixed(0) + ' TL)' : ''}</div>`)
      .join('');
  }
  if (item.note) {
    html += `<div style="font-size:12px;color:#E65100;margin-left:12px;margin-top:2px">📝 Not: ${escapeHtml(item.note)}</div>`;
  }
  return html;
}

function printHtml(html) {
  let iframe = document.getElementById('__print_iframe__');
  if (!iframe) {
    iframe = document.createElement('iframe');
    iframe.id = '__print_iframe__';
    iframe.style.cssText = 'position:fixed;width:0;height:0;border:none;left:-9999px;top:-9999px;';
    document.body.appendChild(iframe);
  }

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(html);
  doc.close();

  setTimeout(() => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
  }, 400);
}

export function printNewOrderReceipt(order, userOrderCounts = {}) {
  if (order.status === 'pending') return;

  const date = order.createdAt?.toDate?.()?.toLocaleString('tr-TR') || new Date().toLocaleString('tr-TR');
  const isNewCustomer = userOrderCounts[order.userId] <= 1;
  const newCustomerHtml = isNewCustomer
    ? `<div class="center" style="margin-bottom:8px;font-size:15px;font-weight:900;border:3px solid #000;padding:4px;">*** YENİ MÜŞTERİ ***</div>`
    : '';
  const items = order.items?.map(item => `
    <div style="margin-bottom:10px">
      <div style="display:flex;justify-content:space-between;align-items:flex-start">
        <div style="font-weight:900;font-size:15px">${item.quantity}x ${escapeHtml(item.name)}</div>
        <div style="font-weight:900;font-size:15px;white-space:nowrap;margin-left:8px">${(item.price * item.quantity).toFixed(0)} TL</div>
      </div>
      ${renderOptions(item)}
    </div>`).join('') || '';

  printHtml(`<!DOCTYPE html>
    <html><head><meta charset="utf-8"><title>Sipariş Fişi</title>
    <style>
      * {margin:0;padding:0;box-sizing:border-box}
      body{font-family:Arial,Helvetica,sans-serif;font-size:14px;width:300px;padding:14px;color:#000;line-height:1.5}
      .center{text-align:center}
      .bold{font-weight:900}
      .divider{border-top:2px dashed #000;margin:10px 0}
      .row{display:flex;justify-content:space-between;margin-bottom:5px;font-size:13px;font-weight:600}
      .large{font-size:17px;font-weight:900}
      .title{font-size:20px;font-weight:900;letter-spacing:1px}
      @media print{body{width:100%}}
    </style>
    </head><body>
    <div class="center title" style="margin-bottom:4px">KADIHAN KEBAP</div>
    <div class="center bold" style="font-size:13px;margin-bottom:10px">Sipariş Fişi</div>
    ${newCustomerHtml}
    <div class="divider"></div>
    <div class="row"><span>Sipariş No:</span><span class="bold">#${order.id.substring(0, 6).toUpperCase()}</span></div>
    <div class="row"><span>Tarih:</span><span>${date}</span></div>
    <div class="row"><span>Müşteri:</span><span class="bold">${escapeHtml(order.userName) || '-'}</span></div>
    ${order.userPhone ? `<div class="row"><span>Hesap Tel:</span><span class="bold">${escapeHtml(order.userPhone)}</span></div>` : ''}
    ${order.addressPhone ? `<div class="row"><span>Teslimat Tel:</span><span class="bold">${escapeHtml(order.addressPhone)}</span></div>` : ''}
    <div class="row"><span>Tür:</span><span class="bold">${order.orderType === 'pickup' ? 'Gel Al' : 'Eve Teslimat'}</span></div>
    ${scheduledLabel(order) ? `<div style="margin:6px 0;padding:6px;border:2px solid #000;font-size:15px;font-weight:800;text-align:center">İLERİ SAATLİ: ${escapeHtml(scheduledLabel(order))}</div>` : ''}
    ${order.address && order.address !== 'Gel Al' ? `<div style="margin-bottom:8px;font-size:13px;font-weight:700"><span>Adres: </span>${escapeHtml(order.address)}</div>` : ''}
    <div class="divider"></div>
    <div class="bold" style="margin-bottom:8px;font-size:14px">Ürünler:</div>
    ${items}
    <div class="divider"></div>
    ${order.discount > 0 ? `<div class="row"><span>İndirim${order.appliedCouponCode ? ' (' + escapeHtml(order.appliedCouponCode) + ')' : ''}:</span><span style="font-weight:900">-${order.discount?.toFixed(0)} TL</span></div>` : ''}
    ${order.deliveryFee > 0 ? `<div class="row"><span>Teslimat Ücreti:</span><span>${order.deliveryFee?.toFixed(0)} TL</span></div>` : ''}
    <div class="row large" style="margin-top:8px;border-top:3px solid #000;padding-top:8px"><span>TOPLAM:</span><span>${order.totalPrice?.toFixed(0)} TL</span></div>
    <div class="row" style="margin-top:6px"><span>Ödeme:</span><span class="bold">${escapeHtml(order.paymentMethod) || '-'}</span></div>
    ${order.note ? `<div class="divider"></div><div style="font-size:13px;font-weight:700"><b>Müşteri Notu:</b> ${escapeHtml(order.note)}</div>` : ''}
    ${order.courierNote ? `<div style="font-size:13px;font-weight:700;margin-top:4px"><b>Kurye Notu:</b> ${escapeHtml(order.courierNote)}</div>` : ''}
    <div class="divider"></div>
    <div class="center bold" style="font-size:13px;margin-top:4px">Afiyet olsun!</div>
    </body></html>`);
}

export function printCancelReceipt(order) {
  const date = order.createdAt?.toDate?.()?.toLocaleString('tr-TR') || '-';
  const items = order.items?.map(item =>
    `<div style="display:flex;justify-content:space-between;margin-bottom:6px;font-size:13px;font-weight:700">
      <span>${item.quantity}x ${escapeHtml(item.name)}</span>
      <span>${(item.price * item.quantity).toFixed(0)} TL</span>
    </div>`
  ).join('') || '';

  printHtml(`<!DOCTYPE html>
    <html><head><meta charset="utf-8"><title>İptal Fişi</title>
    <style>
      * { margin: 0; padding: 0; box-sizing: border-box; }
      body { font-family: Arial,Helvetica,sans-serif; font-size:13px; width:300px; padding:14px; color:#000; line-height:1.5; }
      .center { text-align: center; }
      .bold { font-weight: 900; }
      .divider { border-top: 2px dashed #000; margin: 10px 0; }
      .row { display: flex; justify-content: space-between; margin-bottom: 5px; font-size:13px; font-weight:700; }
      .large { font-size: 16px; font-weight: 900; }
      .cancel { color: #C62828; font-weight: 900; text-align: center; font-size: 14px; border: 3px solid #C62828; padding: 8px; margin: 10px 0; }
      @media print { body { width: 100%; } }
    </style>
    </head><body>
    <div class="center bold" style="font-size:20px;margin-bottom:4px">KADIHAN KEBAP</div>
    <div class="center bold" style="font-size:13px;margin-bottom:8px">İptal Fişi</div>
    <div class="cancel">SİPARİŞ İPTAL EDİLDİ</div>
    <div class="divider"></div>
    <div class="row"><span>Sipariş No:</span><span class="bold">#${order.id.substring(0, 6).toUpperCase()}</span></div>
    <div class="row"><span>Tarih:</span><span>${date}</span></div>
    <div class="row"><span>Müşteri:</span><span class="bold">${escapeHtml(order.userName) || '-'}</span></div>
    ${order.addressPhone ? `<div class="row"><span>Teslimat Tel:</span><span class="bold">${escapeHtml(order.addressPhone)}</span></div>` : ''}
    <div class="row"><span>Tür:</span><span>${order.orderType === 'pickup' ? 'Gel Al' : 'Eve Teslimat'}</span></div>
    ${scheduledLabel(order) ? `<div class="row"><span>İleri saat:</span><span class="bold">${escapeHtml(scheduledLabel(order))}</span></div>` : ''}
    ${order.address && order.address !== 'Gel Al' ? `<div style="margin-bottom:6px;font-size:13px;font-weight:700">Adres: ${escapeHtml(order.address)}</div>` : ''}
    <div class="divider"></div>
    <div class="bold" style="margin-bottom:8px;font-size:13px">İptal Edilen Ürünler:</div>
    ${items}
    <div class="divider"></div>
    ${order.discount > 0 ? `<div class="row"><span>İndirim:</span><span>-${order.discount?.toFixed(0)} TL</span></div>` : ''}
    <div class="row large" style="margin-top:6px;border-top:3px solid #000;padding-top:8px"><span>TOPLAM:</span><span>${order.totalPrice?.toFixed(0)} TL</span></div>
    <div class="row" style="margin-top:4px"><span>Ödeme:</span><span class="bold">${escapeHtml(order.paymentMethod) || '-'}</span></div>
    <div class="divider"></div>
    <div class="center bold" style="font-size:13px;margin-top:4px">İptal işlemi gerçekleştirildi.</div>
    </body></html>`);
}

export function printExtraItemsReceipt(order, newItems) {
  if (!newItems || newItems.length === 0) return;

  const date = new Date().toLocaleString('tr-TR');
  const itemsHtml = newItems.map(item => `
    <div style="margin-bottom:10px">
      <div style="display:flex;justify-content:space-between;align-items:flex-start">
        <div style="font-weight:900;font-size:15px">${item.quantity}x ${escapeHtml(item.name)}</div>
        <div style="font-weight:900;font-size:15px;white-space:nowrap;margin-left:8px">${(item.price * item.quantity).toFixed(0)} TL</div>
      </div>
      ${renderOptions(item)}
    </div>`).join('');
  const extraTotal = newItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);

  printHtml(`<!DOCTYPE html>
    <html><head><meta charset="utf-8"><title>Ekstra Ürün Fişi</title>
    <style>
      * {margin:0;padding:0;box-sizing:border-box}
      body{font-family:Arial,Helvetica,sans-serif;font-size:14px;width:300px;padding:14px;color:#000;line-height:1.5}
      .center{text-align:center}
      .bold{font-weight:900}
      .divider{border-top:2px dashed #000;margin:10px 0}
      .row{display:flex;justify-content:space-between;margin-bottom:5px;font-size:13px;font-weight:700}
      .large{font-size:17px;font-weight:900}
      .extra-box{color:#1565C0;font-weight:900;text-align:center;font-size:14px;border:3px solid #1565C0;padding:8px;margin:10px 0;}
      @media print{body{width:100%}}
    </style>
    </head><body>
    <div class="center bold" style="font-size:20px;margin-bottom:4px">KADIHAN KEBAP</div>
    <div class="center bold" style="font-size:13px;margin-bottom:4px">Ekstra Ürün Fişi</div>
    <div class="extra-box">EKSTRA ÜRÜN EKLENDİ</div>
    <div class="divider"></div>
    <div class="row"><span>Sipariş No:</span><span class="bold">#${order.id.substring(0, 6).toUpperCase()}</span></div>
    <div class="row"><span>Tarih:</span><span>${date}</span></div>
    <div class="row"><span>Müşteri:</span><span class="bold">${escapeHtml(order.userName) || '-'}</span></div>
    ${order.addressPhone ? `<div class="row"><span>Teslimat Tel:</span><span class="bold">${escapeHtml(order.addressPhone)}</span></div>` : ''}
    <div class="divider"></div>
    <div class="bold" style="margin-bottom:8px;font-size:14px">Eklenen Ürünler:</div>
    ${itemsHtml}
    <div class="divider"></div>
    <div class="row large" style="margin-top:6px;border-top:3px solid #000;padding-top:8px"><span>EKSTRA:</span><span>+${extraTotal.toFixed(0)} TL</span></div>
    <div class="row large" style="margin-top:4px"><span>YENİ TOPLAM:</span><span>${order.totalPrice?.toFixed(0)} TL</span></div>
    <div class="divider"></div>
    <div class="center bold" style="font-size:13px;margin-top:4px">Ekstra ürünler mutfağa iletildi.</div>
    </body></html>`);
}
